/* RCPO collection-filter engine — copied VERBATIM from old-theme global.js (lines 949-1316), the collection-filter logic that lives AFTER global.js custom-element defines. rcpo-facets.js calls these helpers (collectionChecked, buttomReset, checkRange, filtertarget, priceCheckbox, customreset, defaultCollection, collectionResetButton, etc.); Arktop global.js lacks them. collectionChecked() auto-checks the matching collection box on the target collection page, firing the facets form so the price/sort/collection params get pushState- d into the URL. Loaded only on RCPO collection pages, before rcpo-facets.js. No customElements.define here, so no clash with Arktop global.js. */

function resizefilter() {
    let win_width = window.innerWidth; // Get the current window width
    let desktopWidth = document.querySelectorAll('details.facets__disclosure');
    let mobileWidth = document.querySelectorAll('details.mobile-facets__details');

    desktopWidth.forEach(element => {
        if (win_width <= 801) {
            element.removeAttribute("open");
        } else {
            element.setAttribute("open", "");
        }
    });

    mobileWidth.forEach(element1 => {
        if (win_width < 801) {
            element1.setAttribute("open", "");
            element1.classList.add('menu-opening');
        } else {
            element1.removeAttribute("open");
            element1.classList.remove('menu-opening');
        }
    });
}

// Initial call to set the filters based on current window size
resizefilter();

// Add event listener for window resize
window.addEventListener('resize', resizefilter);




// loader effect

let loaderImg

/* Price filter JS code for Desktop */

document.querySelector("#Details-2-filter-main-section")?.addEventListener('click', (e) => {
  let target = e.target.closest('.list-menu__item');
  filtertarget(target)
  
});

function filtertarget(target) {
  
  if (target) {
    loaderImg = document.querySelector(".loader-image-section");
    loaderImg.style.display = 'flex';
    let inputValue = target.querySelector("input").value;
    let checkbox = target.querySelector("input").getAttribute("id");
    let pricess = inputValue.replace(/\$/g, '').replace(/,/g, '').replace(/ /g, '').split('-');
    if (checkbox) {
      localStorage.setItem('checkbox', checkbox);
    }
    let priceGTE = document.querySelector('#Filter-Price-GTE');
    let priceLTE = document.querySelector('#Filter-Price-LTE');

    if (priceGTE && priceLTE) {
      if (pricess[1] == '+') {
        pricess[1] = '';
        if (parseInt(pricess[0]) == priceGTE.value && pricess[1] == priceLTE.value) {
          priceGTE.value = null;
          priceLTE.value = null;

          let inputEvent = new Event('input', { bubbles: true });
          priceGTE.dispatchEvent(inputEvent);
          priceLTE.dispatchEvent(inputEvent);
          localStorage.setItem('priceRange', JSON.stringify(pricess));
        } else {
          priceGTE.value = parseInt(pricess[0]);
          priceLTE.value = null;

          let inputEvent = new Event('input', { bubbles: true });
          priceGTE.dispatchEvent(inputEvent);
          priceLTE.dispatchEvent(inputEvent);
          localStorage.setItem('priceRange', JSON.stringify(pricess));
        }

      } else {
        if (parseInt(pricess[0]) == priceGTE.value && parseInt(pricess[1]) == priceLTE.value) {
          priceGTE.value = null;
          priceLTE.value = null;

          let inputEvent = new Event('input', { bubbles: true });
          priceGTE.dispatchEvent(inputEvent);
          priceLTE.dispatchEvent(inputEvent);
          localStorage.setItem('priceRange', JSON.stringify(pricess));

        } else {
          priceGTE.value = parseInt(pricess[0]);
          priceLTE.value = parseInt(pricess[1]);

          let inputEvent = new Event('input', { bubbles: true });
          priceGTE.dispatchEvent(inputEvent);
          priceLTE.dispatchEvent(inputEvent);
          localStorage.setItem('priceRange', JSON.stringify(pricess));
        }
      }
    }
    priceCheckbox();
  }
}

document.addEventListener('DOMContentLoaded', () => {
   loaderImg = document.querySelector(".loader-image-section");
  priceCheckbox();
});

function priceCheckbox() {
  let priceSplite
  setTimeout(() => {
    loaderImg.style.display = 'none';
    let pricess = JSON.parse(localStorage.getItem('priceRange'));
    let inputId = localStorage.getItem('checkbox');
    let checkbox
    if(window.innerWidth >= 801){
       checkbox = document.getElementById(inputId).nextElementSibling.nextElementSibling;
    } else {
       checkbox = document.getElementById(inputId).nextElementSibling.nextElementSibling.nextElementSibling;
    }
    if (location.search.includes('price')) {
      let range = []
      priceSplite = location.search.replace('?', '').split('&')
      let priveFilterr = priceSplite.filter(price => price.includes('price'))
      priveFilterr.forEach(price => {
        range.push(price.split('=')[1])
      })

      if (pricess[0] == range[0] && pricess[1] == range[1]) {
        checkbox.style.visibility = "visible";
      } else {
        checkbox.style.visibility = "hidden";
      }
    }
  }, 2000)
  }


/* Price filter JS code for Mobile */

document.querySelector("#Details-Mobile-2-filter-main-section")?.addEventListener('click', (e) => {
  let target1 = e.target.closest('.list-menu__item');
  filtertarget(target1)
})

document.addEventListener('DOMContentLoaded', () => {
  checkRange();
});

//price filter check
function checkRange(){
  checker()
  function numformate(num) {
    if(num){
      const hasDecimal = num % 1 !== 0; // Check if the number has a decimal part
      const options = {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: hasDecimal ? 2 : 0,
          maximumFractionDigits: hasDecimal ? 2 : 0
      };
      
      const currencyFormatter = new Intl.NumberFormat('en-US', options);
      const formattedCurrency = currencyFormatter.format(num);
      return formattedCurrency;
    }else{
      return '+';
    }
   
  }
  
  function getNextSiblingWithClass(element, className) {
    let sibling = element.nextElementSibling;
  
    while (sibling) {
        if (sibling.classList.contains(className)) {
            return sibling;
        }
        sibling = sibling.nextElementSibling;
    }
  
    return null; // Return null if no matching sibling is found
  }
  
  if(document.querySelector('#Filter-Price-GTE').value){
  let lte = numformate(document.querySelector('#Filter-Price-LTE').value)
  let gte = numformate(document.querySelector('#Filter-Price-GTE').value)
  let checkboxInput = document.querySelectorAll(`input[value="${gte} - ${lte}"]`)
    
    checkboxInput.forEach(ele=>{
        const iconCheckmark = getNextSiblingWithClass(ele, 'icon-checkmark');
      
      if(ele.parentElement.parentElement.parentElement.parentElement.querySelector('.individual-reset-buttom')){
        ele.parentElement.parentElement.parentElement.parentElement.querySelector('.individual-reset-buttom').classList.add('visible')
      }
         const fontWeight = iconCheckmark.nextElementSibling;
        iconCheckmark.style.visibility='visible';
      fontWeight.style.fontWeight='bold';
    })
  }
}


document.addEventListener('DOMContentLoaded', () => {
  buttomReset()
  customreset();
  if (window.location.pathname !== '/collections/rolex-certified-pre-owned-watches') {
    defaultCollection();
  }
  collectionChecked();
  collectionResetButton()
  
});

function customreset() {
  // Using event delegation
 const mobileFacets = document.querySelector('.mobile-facets__main');
   mobileFacets.addEventListener('click', event => {
    if (event.target.classList.contains('individual-reset-buttom')) {
      let button = event.target;
      let parent = button.parentElement;
      let sibling = parent.nextElementSibling;
      let ancestor = parent.parentElement.parentElement
      if (sibling) {
        if (ancestor.id === "Details-Mobile-2-filter-main-section") {
          let targetInputs = sibling.querySelectorAll('li');
          targetInputs.forEach(label => {
            let checkboxField = label.querySelector('.icon-checkmark');
            if (checkboxField.style.visibility === "visible") {
              label.click();
            }
          });
        } else {
          let targetInputs = sibling.querySelectorAll('li label');
          targetInputs.forEach(label => {
            let checkboxField = label.querySelector('input[type="checkbox"]');
            if (checkboxField.checked) {
              label.click();
              checkRange();
              visiblereset()
            }
          });
        }
      }
      setTimeout( ()=>{
        mobileFacets.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }, 2000)
       
    }      
  });
}

// 27-sep-2024 start

// custom collection checked
let desktopCustomCollectionList = document.querySelectorAll(".desktop-custom-collection-filter .parent-display .facets__list.list-unstyled .list-menu__item a");
let mobileCustomCollectionList = document.querySelectorAll(".mobile-custom-collection-filter .mobile-facets__list.list-unstyled .mobile-facets__item a");
function collectionChecked() {

  function applyCheckboxLogic(win_width) {
    if (win_width <= 800) {
      mobileCustomCollectionList.forEach(item => {
        let match1 = item.href;
        if (match1.includes(window.location.pathname)) {
          
          let iid= item.children[0].id
          setTimeout(()=>{
            let inputs = document.querySelectorAll(`[id="${iid}"]`);
            input = inputs.length > 1 ? inputs[inputs.length -1] : inputs[0];
            input.checked = true;
          },1500)
        }
      });
    } else {
      desktopCustomCollectionList.forEach(item => {        
        let match = item.href;
        if (match.includes(window.location.pathname)) {
          let iid= item.children[0].id;
          
          setTimeout(()=>{
            let inputs = document.querySelectorAll(`[id="${iid}"]`);
            input = inputs.length > 1 ? inputs[inputs.length -1] : inputs[0];
            input.checked = true;
            let acc = input.closest('details');
            acc.setAttribute('open', '');
            acc.querySelector('summary').classList.add('active');
          },1500)
          
        }
      });
    }
  }

  applyCheckboxLogic(window.innerWidth);

  window.addEventListener('resize', function() {
    applyCheckboxLogic(window.innerWidth);
  });
}



//  default collection checked

if (window.location.pathname !== '/collections/rolex-certified-pre-owned-watches') {
  function defaultCollection() {
    let desktopCollectionList = document.querySelectorAll(".disclosure-has-popup .parent-display legend");
  
    for (let ele of desktopCollectionList) {
        let matchTitle = ele.textContent || ele.innerText;
        if (matchTitle.toLowerCase().includes('collection')) {
            let nextElement = ele.nextElementSibling;
            
            if (nextElement) {
                let checkbox1 = nextElement.querySelector('label input[type="checkbox"]');
                if (checkbox1 && !checkbox1.checked) {
                    checkbox1.click();
                    break;
                }
            } else {
                console.warn('Next sibling not found for:', ele);
            }
        }
    }
}


  function collectionResetButton() {
    let collectionReset = document.querySelector('.mobile-custom-collection-filter .option-top-section-with-reset-section .individual-reset-buttom');
    collectionReset.style.setProperty('visibility', 'visible', 'important');
    collectionReset.addEventListener('click', (e) => {
        window.location.href = '/collections/rolex-certified-pre-owned-watches';
    });
  }
  
}

// reset button
function buttomReset() {
  let customReset = document.querySelectorAll('.custom-reset-btn a');
  let mobileCustomReset = document.querySelectorAll('.active-facets.active-facets-mobile');
  let desktopDustomReset = document.querySelectorAll('.active-facets.active-facets-desktop');
  
customReset.forEach(ele => {
    ele.addEventListener('click', (e) => {
        window.location.href='/collections/rolex-certified-pre-owned-watches';
    });
})

mobileCustomReset.forEach(ele => {
    ele.addEventListener('click', (e) => {
        window.location.href='/collections/rolex-certified-pre-owned-watches';
    });
})
  desktopDustomReset.forEach(ele => {
    ele.addEventListener('click', (e) => {
        window.location.href='/collections/rolex-certified-pre-owned-watches';
    });
})
  
}

